import { useState, useEffect } from "react";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import api from "../../utils/api";

// Weekly scans by code format: shows legacy packaging draining out as GS1 codes take over
const TransitionChart = ({ queryParams }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/api/analytics/transition?${queryParams}`).then((r) => setData(r.data)).catch(console.error).finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) return <div className="text-center py-4"><div className="spinner-border spinner-border-sm" role="status" /></div>;
  if (data.length === 0) return <p className="text-muted text-center mb-0">No scans in the selected date range.</p>;

  const latest = data[data.length - 1];
  const latestTotal = latest.gs1 + latest.standard + latest.legacy;
  const gs1Share = latestTotal ? Math.round((100 * latest.gs1) / latestTotal) : 0;

  return (
    <div>
      <p className="text-muted small mb-2">Weekly scans by the format of the code scanned. Latest week: {gs1Share}% GS1 Digital Link.</p>
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} />
          <Tooltip />
          <Legend />
          <Area type="monotone" dataKey="legacy" name="Legacy" stackId="1" stroke="#6c757d" fill="#6c757d" fillOpacity={0.5} />
          <Area type="monotone" dataKey="standard" name="Standard" stackId="1" stroke="#fd7e14" fill="#fd7e14" fillOpacity={0.5} />
          <Area type="monotone" dataKey="gs1" name="GS1 Digital Link" stackId="1" stroke="#20c997" fill="#20c997" fillOpacity={0.6} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TransitionChart;
